/**
 * MobileInstructions - View component for mobile usage instructions
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function MobileInstructions() {
  return (
    <div style={styles.mobileInstructions}>
      On mobile, choose the Camera option to take a photo instead of uploading.
    </div>
  );
}

const styles = {
  mobileInstructions: {
    fontSize: '0.9em',
    color: '#666',
    marginTop: 8,
    marginBottom: 12
  }
};
